import { Col, message, Row } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { admissionService } from '../../services/admission';
import { admissionPatientService } from '../../services/admissionPatient';
import { getCookie } from "../../services/cookies";
import AdmissionDetails from './components/AdmissionDetails';
import AdmissionSettings from './components/AdmissionSettings';
import { getActiveProviders } from '../../services/providers';

const AdmissionPage = () => {
  const [loading, setLoading] = useState(
    {
      reservation: false,
      paymentMethods: false,
      patients: false
    }
  );
  const [startAdmission, setStartAdmission] = useState(false);
  const [reservation, setReservation] = useState();
  const [admittedPatients, setAdmittedPatients] = useState();
  const [patientToAdmission, setPatientToAdmission] = useState();
  const { id } = useParams();
  const countryCode = getCookie("country_code");
  const [laboratoryModule, setLaboratoryModule] = useState(null);
  const [providerCode, setProviderCode] = useState();

  const fetchReservation = useCallback(async () => {
    try {
      setLoading(loading => ({ ...loading, reservation: true }));
      const [response] = await admissionService.getReservation({ reservationId: id });
      setReservation(response);
    } catch (error) {
      console.error(error);
      message.error({
        content: `Error al obtener la reserva`,
        style: {
          marginTop: "35vh",
          fontSize: 16,
        },
      });
    } finally {
      setLoading(loading => ({ ...loading, reservation: false }));
    }
  }, [id]);

  const fetchAdmittedPatients = useCallback(async () => {
    try {
      setLoading(loading => ({ ...loading, patients: true }));
      const response = await admissionService.getAdmittedPatients({
        reservationId: id,
        ...(providerCode && { providerCode })
      });
      const admitted = response.map(patient => ({ ...patient, showEvaluationTypePopover: false }));
      setAdmittedPatients(admitted);
    } catch (error) {
      console.error(error);
      message.error({
        content: `Error al obtener los pacientes admitidos`,
        style: {
          marginTop: "35vh",
          fontSize: 16,
        },
      });
    } finally {
      setLoading(loading => ({ ...loading, patients: false }));
    }
  }, [id, providerCode]);

  const fetchLaboratoryIntegration = useCallback(async () => {
    try {
      setLoading(loading => ({ ...loading, patients: true }));
      const providers = getActiveProviders();
      setProviderCode(providers?.[reservation.branch_office_id]?.laboratory?.[0]);
      setLaboratoryModule(providers?.[reservation.branch_office_id]?.laboratory ? true : false);
    } catch (error) {
      console.error(error);
      message.error({
        content: `Error al obtener la integración de laboratorio`,
        style: {
          marginTop: "35vh",
          fontSize: 16,
        },
      });
    } finally {
      setLoading(loading => ({ ...loading, patients: false }));
    }
  }, [id, reservation?.branch_office_id]);


  useEffect(() => {
    fetchReservation();
  }, [fetchReservation]);

  useEffect(() => {
    if (reservation?.branch_office_id) {
      fetchLaboratoryIntegration();
    }
  }, [reservation?.branch_office_id, fetchLaboratoryIntegration]);

  useEffect(() => {
    if (laboratoryModule !== null) {
      fetchAdmittedPatients();
      fetchReservation();
    }
  }, [laboratoryModule, fetchAdmittedPatients, startAdmission]);

  const closeEvaluationTypePopover = () => {
    const admitted = admittedPatients.map(patient => ({ ...patient, showEvaluationTypePopover: false }));
    setAdmittedPatients(admitted);
  };

  const evaluationTypeOnFinish = async (values, item) => {
    try {
      await admissionPatientService.postEvaluationType({
        evaluation_type: values.evaluationType,
        admission_patient_id: item.admission_patient_id,
        reservation_id: id,
      });
      fetchAdmittedPatients();
      closeEvaluationTypePopover();
    } catch (error) {
      console.error(error);
      message.error({
        content: `Error al cambiar el tipo de evaluación`,
        style: {
          marginTop: "35vh",
          fontSize: 16,
        },
      });
    }
  };

  return (
    <Row justify="center" className='admission-page'>
      <Col lg={24} xs={24}>
        {
          !startAdmission ?
            <AdmissionDetails
              id={id}
              loading={loading}
              setLoading={setLoading}
              reservation={reservation}
              setReservation={setReservation}
              setStartAdmission={setStartAdmission}
              admittedPatients={admittedPatients}
              countryCode={countryCode}
              laboratoryModule={laboratoryModule}
              providerCode={providerCode}
              evaluationTypeOnFinish={evaluationTypeOnFinish}
              closeEvaluationTypePopover={closeEvaluationTypePopover}
            />
            :
            <AdmissionSettings
              id={id}
              reservation={reservation}
              setStartAdmission={setStartAdmission}
              patientToAdmission={patientToAdmission}
              setPatientToAdmission={setPatientToAdmission}
              countryCode={countryCode}
              providerCode={providerCode}
              laboratoryModule={laboratoryModule}
            />
        }
      </Col>
    </Row>
  );
};

export default AdmissionPage;